module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai106-eb43d6705f19fd0fb1d5fe399cc7ac86.jpg";